export const appointmentReducers = {
    // Set only by addAppointment() (appointmentThunks.js), in the same
    // try/finally that owns the in-flight de-duplication key.
    setBookingInFlight(state, action) {
        state.bookingInFlight = action.payload;
    },
    saveAppointment(state, action) {
        state.isLoading = false;
        state.createLead = {
            ...state.createLead,
            lead_appointment: action.payload
        };
    },
    followUpLead(state, action) {
        state.followLead = { ...action.payload };
        state.newLeadDetail.personalDetail = action.payload;
        // Extract appointments from lead_treatments into lead_appointment so
        // AttendedAppointment can access them with full nested assignee objects.
        // The separate /appointments/ endpoint returns assignees as bare IDs,
        // but the lead detail nests them via AppointmentReadOnlySerializer.
        const treatments = action.payload?.lead_treatments;
        if (treatments?.length) {
            const allAppointments = treatments.flatMap((t) => t.appointments || []);
            if (allAppointments.length > 0) {
                state.followLead.lead_appointment = allAppointments;
            }
        }
    },
    setFollowLeadNotFound(state, action) {
        state.followLeadNotFound = action.payload;
    },
    setFollowUpTableMoved(state, action) {
        state.followUpTableMoved = action.payload;
    },
    clearFollowUpTableMoved(state) {
        state.followUpTableMoved = null;
    },
    isAppointment(state, action) {
        state.isLoading = false;
        state.isAppointmentBooked = action.payload;
    },
    followUpAppointment(state, action) {
        state.isLoading = false;
        state.followLead = {
            ...state.followLead,
            lead_appointment: action.payload
        };
    },
    updateFollowUpLead(state, action) {
        state.followUpLead = action.payload;
    },
    appointmentNotesSlice(state, action) {
        state.appointmentNotes = action.payload;
    },
    appointmentDateSlice(state, action) {
        state.appointmentDateValue = action.payload;
    },
    appointmentUserSlice(state, action) {
        state.appointmentUserValue = action.payload;
    },
};
